<template>
  <form id="create_ticket_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن تیکت</h3>
        </div>
      </div>

      <div class="card-body">
        <div class="form-group">
          <label>عنوان <span class="text-danger">*</span></label>
          <input type="text" name="title" v-model="form.title" class="form-control"
            placeholder="عنوان تیکت را وارد کنید" />
        </div>

        <div class="form-group">
          <label>اولویت <span class="text-danger">*</span></label>
          <div class="radio-inline">
            <label v-for="(type, key) in ticketPriority" :key="`type-${key}`" class="radio">
              <input type="radio" name="type" :value="key" v-model="form.priority" />
              <span></span>
              {{ type }}
            </label>
          </div>
        </div>

        <div class="form-group">
          <label>پیام <span class="text-danger">*</span></label>
          <textarea v-model="form.message" id="message" class="form-control message-textarea" rows="6"
            placeholder="پیام خود را بنویسید... (Enter برای خط جدید)" @keydown.enter.exact.prevent
            @keyup.enter.exact="addNewLine"></textarea>
          <small class="form-text text-muted mt-2">
            پیام خود را بنویسید
          </small>
        </div>
      </div>

      <!-- <div class="card-footer text-right">
        <button
          type="button"
          class="btn btn-primary font-weight-bolder"
          :disabled="isSubmitting"
          @click="save"
        >
          <b-spinner v-if="isSubmitting" small class="small" class="mr-2"></b-spinner>
          {{ isSubmitting ? 'در حال ارسال...' : 'ارسال تیکت' }}
        </button>
      </div> -->
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  STORE_TICKET,
  STORE_TICKET_MESSAGE
} from "@/core/services/store/tickets.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "tickets-create",
  props: ["id"],

  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      isSubmitting: false, 
      form: {
        title: "",
        priority: "",
        message: ""
      },
      fv: null
    };
  },

  mounted() {
    this.setBreadcrumbs();
    this.setActions();
    this.eventHub.$on("save-ticket-event", this.save);

    this.fv = formValidation(document.getElementById("create_ticket_form"), {
      fields: {
        title: {
          validators: {
            notEmpty: { message: "عنوان الزامی است" },
            stringLength: { min: 3, max: 128, message: "عنوان باید بین ۳ تا ۱۲۸ کاراکتر باشد" }
          }
        },
        type: {
          validators: {
            notEmpty: { message: "لطفاً یک اولویت انتخاب کنید" }
          }
        },
        message: {
          selector: "#message",
          validators: {
            notEmpty: { message: "پیام الزامی است" },
            stringLength: { min: 5, max: 2000, message: "پیام باید بین ۵ تا ۲۰۰۰ کاراکتر باشد" }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },

  beforeDestroy() {
    this.eventHub.$off("save-ticket-event");
    this.enableSaveButton();
  },

  computed: {
    ...mapGetters(["currentUserProperty", "ticket", "ticketPriority"])
  },

  methods: {
    setBreadcrumbs() {
      const ticketsRouteName = "tickets-index";
      const items = [
        { title: "پشتیبانی", route: { name: ticketsRouteName } },
        { title: "افزودن تیکت" }
      ];
      this.$store.dispatch(SET_BREADCRUMB, items);
    },

    setActions() {
      const ticketsRouteName = "tickets-index";
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-ticket-event",
            class: "btn-primary",
            id: "save-ticket-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: ticketsRouteName }
          }
        ]
      });
    },

    save() {
      if (this.isSubmitting) return;

      this.fv.validate().then(status => {
        if (status !== "Valid") {
          this.$bvToast.toast("لطفاً همه فیلدها را به درستی پر کنید", {
            title: "خطا در فرم",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-center"
          });
          return;
        }

        this.isSubmitting = true;
        this.disableSaveButton();

        const payload = {
          user: this.isCompany || this.isAdmin ? this.$route.params.id : null,
          title: this.form.title,
          priority: parseInt(this.form.priority)
        };

        let newTicketId = null;

        this.$store.dispatch(STORE_TICKET, payload)
          .then(response => {
            newTicketId = response.id || response.data?.id || response;

            return this.$store.dispatch(STORE_TICKET_MESSAGE, {
              id: newTicketId,
              formData: { content: this.form.message }
            });
          })
          .then(() => {
            // موفقیت — با toast ساده و مطمئن
            this.$bvToast.toast("تیکت با موفقیت ارسال شد", {
              title: "موفقیت",
              variant: "success",
              solid: true,
              autoHideDelay: 3000
            });

            this.$router.push({
              name: "tickets-show",
              params: { id: newTicketId }
            }).catch(() => { });
          })
          .catch(() => {
            this.$bvToast.toast("خطا در ارسال تیکت. لطفاً دوباره تلاش کنید", {
              title: "خطا",
              variant: "danger",
              solid: true
            });
          })
          .finally(() => {
            this.isSubmitting = false;
            this.enableSaveButton();
          });
      });
    },

    disableSaveButton() {
      const btn = document.getElementById("save-ticket-btn");
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="spinner spinner-white mr-2"></span>در حال ارسال...';
      }
    },

    enableSaveButton() {
      const btn = document.getElementById("save-ticket-btn");
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = 'ذخیره';
      }
    },
    addNewLine(e) {
      this.form.message += "\n";
      this.$nextTick(() => {
        const el = e.target;
        el.selectionStart = el.selectionEnd = el.value.length;
      });
    },
    formatMessage(text) {
      if (!text) return "";

      let formatted = text
        .replace(/\n/g, "<br>")
        .replace(
          /(https?:\/\/[^\s<]+[^\s<.,;:!?])/g,
          '<a href="$1" target="_blank" class="text-primary font-weight-bold">$1</a>'
        );

      return formatted;
    }
  }
};
</script>

<style scoped>
.form-control.is-invalid {
  border-color: #F64E60;
}
.message-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
  line-height: 1.6;
}

.message-textarea:focus {
  border-color: #4F46E5;
  box-shadow: 0 0 0 0.2rem rgba(79, 70, 229, 0.25);
}
</style>